<template>
    <button style="border:1px solid black;padding:12px;cursor:pointer;border-radius: 2px;" @click="openSignaturePad">Click me</button>
  <signature-pad :key="updateModalKey" :show-signature-pad="showSignatureModal"  @signature-image="getSignatureImage" @emit-signature="getSignature"></signature-pad>
</template>

<script>
import SignaturePad from '@/components/SignaturePad.vue';
export default {
components:{
    SignaturePad

},
emits:["signature-base"],
    data(){
        return{
            signatureBase:"",
            showSignatureModal:true,
        }
    },
    mounted(){
this.updateModalKey++
    },
methods:{
    openSignaturePad(){
        this.showSignatureModal=true
        console.log("openSignaturePad from view", this.showSignatureModal)
    }
}
}
</script>

<style>

</style>